<!-- クライアントマスタ　詳細画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wjgyo">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>クライアントマスタ<span>詳細</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<div class="btnLst">
					<button class="nextBtn" v-on:click="onTarget">対象者区分設定</button>
					<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
				</div>
				<table class="inputTbl">
					<thead>
						<tr>
							<th>項目名称</th>
							<td>登録内容</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>名称</th>
							<td>
								<ul class="nameH">
									<li><input type="text" v-model="singleJGYO.JGNM" placeholder="名称"></li>
									<li><span>カナ</span><input type="text" v-model="singleJGYO.JGKN" placeholder="カナ"></li>
									<li><span>略称</span><input type="text" v-model="singleJGYO.JGRY" placeholder="略称"></li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>保険者番号</th>
							<td><input type="text" class="hksh" v-model="singleJGYO.HKSH" maxlength="8" placeholder="保険者番号"></td>
						</tr>
						<tr>
							<th>年齢起算条件</th>
							<td>
								<select v-model="singleJGYO.KSFG" v-on:change="onChange">
									<option value="0">起算日による(年内)</option>
									<option value="1">起算日による(翌年)</option>
									<option value="2">健診日当日</option>
								</select>
								<dl class="dayForm">
									<dt>起算日</dt>
										<dd>
											<ul class="md">
												<li><input type="text" v-model.number="singleJGYO.KSMM" v-bind:disabled="isPush" maxlength="2" placeholder="XX"></li>
												<li><input type="text" v-model.number="singleJGYO.KSDD" v-bind:disabled="isPush" maxlength="2" placeholder="XX"></li>
											</ul>
										</dd>
								</dl>
							</td>
						</tr>
						<tr>
							<th>使用可能</th>
							<td>
								<ul class="radioLst">
									<li><label for="VSBLyes" class="radio"><input type="radio" id="VSBLyes" value="1" v-model="singleJGYO.VSBL"><span>可能</span></label></li>
									<li><label for="VSBLno" class="radio"><input type="radio" id="VSBLno" value="2" v-model="singleJGYO.VSBL"><span>不可</span></label></li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>予約方法</th>
							<td>
								<ul class="radioLst">
									<li><label for="CALNconfirm" class="radio"><input type="radio" id="CALNconfirm" value="1" v-model="singleJGYO.CALN"><span>予約確定</span></label></li>
									<li><label for="CALNhope" class="radio"><input type="radio" id="CALNhope" value="2" v-model="singleJGYO.CALN"><span>希望予約</span></label></li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>ゲスト予約</th>
							<td>
								<ul class="radioLst">
									<li><label for="GESTyes" class="radio"><input type="radio" id="GESTyes" value="1" v-model="singleJGYO.GEST"><span>可能</span></label></li>
									<li><label for="GESTno" class="radio"><input type="radio" id="GESTno" value="2" v-model="singleJGYO.GEST"><span>不可</span></label></li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>クライアント専用URL</th>
							<td><input type="text" v-model="singleJGYO.URL" placeholder="クライアントURL"></td>
						</tr>
						<tr>
							<th>問診表表示</th>
							<td>
								<ul class="radioLst">
									<li><label for="MNSNhide" class="radio"><input type="radio" id="MNSNhide" value="0" v-model="singleJGYO.MNSN"><span>非表示</span></label></li>
									<li><label for="MNSNdisplay" class="radio"><input type="radio" id="MNSNdisplay" value="1" v-model="singleJGYO.MNSN"><span>表示</span></label></li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>予約案内メール送信間隔</th>
							<td><input type="text" class="date" v-model.number="singleJGYO.REMD" maxlength="2" placeholder="XX"> 日前</td>
						</tr>
						<tr>
							<th>予約促進メール送信間隔</th>
							<td><input type="text" class="date" v-model.number="singleJGYO.JKSD" maxlength="2" placeholder="XX"> 月後</td>
						</tr>
						<tr>
							<th>金額表示</th>
							<td>
								<ul class="radioLst">
									<li><label for="KSHJhide" class="radio"><input type="radio" id="KSHJhide" value="0" v-model="singleJGYO.KSHJ"><span>非表示</span></label></li>
									<li><label for="KSHJdisplay" class="radio"><input type="radio" id="KSHJdisplay" value="1" v-model="singleJGYO.KSHJ"><span>表示</span></label></li>
								</ul>
							</td>
						</tr>
					</tbody>
				</table>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onUpdateCancel">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WJGYODetailApi } from '@/api'
	import { WJGYODetailUpdateApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWJGYODetail',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow,
		},
		data() {
			return {
				singleJGYO: {
          // 名称
          JGNM: '',
          // カナ名称
          JGKN: '',
          // 略称
          JGRY: '',
          // 保険者番号
          HKSH: '',
          // 年齢起算条件(0:起算日による(年内) 1:起算日による(翌年) 2:健診日当日 )
          KSFG: '',
          // 年齢起算月
          KSMM: '',
          // 年齢起算日
          KSDD: '',
          // 使用可能(1:可 2:不可)
          VSBL: '',
          // 予約方法(1:確定予約　2:希望予約)
          CALN: '',
          // ゲスト予約(1:可　2:不可)
          GEST: '',
          // 専用ページアドレス
          URL : '',
          // 問診票表示(0:非表示 1:表示)
          MNSN: '',
          // リマインドメール送信間隔
          REMD: '',
          // 予約促進メール送信間隔
          JKSD: '',
          // 金額表示
          KSHJ: ''
        },
				isPush: false,
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWJGYODetail::created Start')

			var tempircd = this.$store.state.auth.ircd

			var tempjgcd = this.$store.state.adminUserChoice.MasterWJGYO.jgcd

			// 非同期通信
			WJGYODetailApi.Detail({
				token: this.$store.state.auth.token,
				ircd: tempircd,
				jgcd: tempjgcd
			}).then(({ responce }) => {

				if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

					this.singleJGYO = responce.data.singleJGYO

					if (this.singleJGYO.KSFG == 2) {
						this.isPush = true
					}

				} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
					|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
					|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
					// システム、DBエラー時
					this.onSystemErrorModalOpen()
				}
			}).catch(() => {
				// システムエラー時
				this.onSystemErrorModalOpen()
			}).finally(() => {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::created End')
			})
		},
		methods: {
			//起算条件が当日の時は起算日の入力を非活性
			onChange: function () {
				if (this.singleJGYO.KSFG == 2) {
					this.isPush = true
					this.singleJGYO.KSMM = 0
					this.singleJGYO.KSDD = 0
				} else {
					this.isPush = false
				}
			},
			onUpdate: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onUpdate Start")        

				var tempircd = this.$store.state.auth.ircd
				var tempjgcd = this.$store.state.adminUserChoice.MasterWJGYO.jgcd
				var tempjgnm = this.singleJGYO.JGNM
				var tempjgkn = this.singleJGYO.JGKN
				var tempjgry = this.singleJGYO.JGRY
				var temphksh = this.singleJGYO.HKSH
				var tempksfg = this.singleJGYO.KSFG
				var tempksmm = this.checkNumber(this.singleJGYO.KSMM)
				var tempksdd = this.checkNumber(this.singleJGYO.KSDD)
				var tempvsbl = this.singleJGYO.VSBL
				var tempcaln = this.singleJGYO.CALN
				var tempgest = this.singleJGYO.GEST
				var tempurl = this.singleJGYO.URL
				var tempmnsn = this.singleJGYO.MNSN
				var tempremd = this.checkNumber(this.singleJGYO.REMD)
				var tempjksd = this.checkNumber(this.singleJGYO.JKSD)
				var tempkshj = this.singleJGYO.KSHJ        


				WJGYODetailUpdateApi.DetailUpdate({
					token: this.$store.state.auth.token,
					ircd: tempircd,
					jgcd: tempjgcd,
					jgnm: tempjgnm,
					jgkn: tempjgkn,
					jgry: tempjgry,
					hksh: temphksh,
					ksfg: tempksfg,
					ksmm: tempksmm,
					ksdd: tempksdd,
					vsbl: tempvsbl,
					caln: tempcaln,
					gest: tempgest,
					url: tempurl,
					mnsn: tempmnsn,
					remd: tempremd,
					jksd: tempjksd,
					kshj: tempkshj
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						//更新確認モーダルを閉じる
						this.onConfirmUpdateModalOpen()
						//更新完了モーダルを開く
						this.$router.push("/MasterWJGYODetailUpdate")

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
						//入力項目でのエラー
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					}

				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWJGYODetail::onUpdate End')
				})
			},
			// 対象者区分に遷移
			onTarget: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onCancel Start")

				this.$router.push("/MasterWHFKBList")

				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onCancel End")
			},
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onCancel Start")

				this.$router.push("/MasterWJGYOList")

				this.$store.commit(types.ADMIN_USERCHOICE_WJGYO_LISTTODETAIL, {jgcd: ''})

				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onCancel End")
			},
			// 更新ボタン押下時の入力エラー 
			validationOnUpdate: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::validationOnUpdate Start')

				var errorMessages = []

				var tempKsmm = this.checkNumber(this.singleJGYO.KSMM)
				var tempKsdd = this.checkNumber(this.singleJGYO.KSDD)
				var tempRemd = this.checkNumber(this.singleJGYO.REMD)
				var tempJksd = this.checkNumber(this.singleJGYO.JKSD)

				if((this.singleJGYO.KSFG == '0' || this.singleJGYO.KSFG == '1') && tempKsmm == -1) {
					errorMessages.push('年齢起算月は半角数字で入力してください。')
				} else if((this.singleJGYO.KSFG == '0' || this.singleJGYO.KSFG == '1') && tempKsmm == 0) {
					errorMessages.push('年齢起算月が入力されていません。')
				}

				if((this.singleJGYO.KSFG == '0' || this.singleJGYO.KSFG == '1') && tempKsdd == -1) {
					errorMessages.push('年齢起算日は半角数字で入力してください。')
				} else if((this.singleJGYO.KSFG == '0' || this.singleJGYO.KSFG == '1') && tempKsdd == 0) {
					errorMessages.push('年齢起算日が入力されていません。')
				}

				if(tempRemd == -1) {
					errorMessages.push('受診前確認メール送信間隔は半角数字で入力してください。')
				}

				if(tempJksd == -1) {
					errorMessages.push('予約促進メール送信間隔は半角数字で入力してください。')
				}

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::validationOnUpdate End')

				return errorMessages
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::checkNumber End')

				return tempValue
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})
				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onConfirmUpdateModalOpen Start')

				// エラーチェック
				var tempErrorMessages = this.validationOnUpdate()

				if(tempErrorMessages.length > 0) {
					this.onValidationErrorModalOpen(tempErrorMessages)
					return
				}

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::onConfirmUpdateModalClose End')
			},
			// 更新確認モーダルで表示画面に戻る
			onUpdateCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onUpdateCancel Start")

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog("MasterWJGYODetail::onUpdateCancel End")
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWJGYODetail::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWJGYODetail::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WJGYO/MasterWJGYODetail.vue